export default __webpack_public_path__ + "static/media/radioplay.8a3b534e.svg";